import Dexie, { Table } from "dexie";
import { Customer } from "../../models/customer.model";
import { Product } from "../../models/product.model";

export class AppIndexedDB extends Dexie {
  products!: Table<Product, string>;
  customers!: Table<Customer, string>;

  constructor() {
    super("ngdexieliveQuery");
    this.version(1).stores({
      // products: "id,shopId,barcode",
      // customers: "id,shopId,fullName,mobile",
      products: "id",
      customers: "id",
    });
  }

  async resetDatabase(table?: string) {
    switch (table) {
      case "products":
        await indexedDb.transaction("rw", "products", () => {
          this.products.clear();
        });
        break;
      case "customers":
        await indexedDb.transaction("rw", "customers", () => {
          this.customers.clear();
        });
        break;
      default:
        await indexedDb.transaction("rw", "products", "customers", () => {
          this.products.clear();
          this.customers.clear();
        });
        break;
    }
  }
}

export const indexedDb = new AppIndexedDB();
